import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then(r => setOrder(r.data)); }, [id]);
  if (!order) return <div className="lumina-container py-20 text-center text-[#5C5870]">Memuat…</div>;
  return (
    <div className="lumina-container py-16 max-w-2xl" data-testid="order-success-page">
      <div className="lumina-card p-10 text-center">
        <div className="w-20 h-20 rounded-full bg-[#E8F0FA] flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-10 h-10 text-[#6B4BA3]" />
        </div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-2">Pembayaran Berhasil!</h1>
        <p className="text-[#5C5870] mb-6">Terima kasih, {order.customer_name}. Pesananmu sudah kami terima.</p>
        <div className="bg-[#E8F0FA]/40 rounded-2xl p-5 mb-6 text-left">
          <div className="text-xs text-[#5C5870] uppercase tracking-wider mb-1">No. Pesanan</div>
          <div className="font-mono font-medium text-[#1A1728]">{order.order_number}</div>
          <div className="mt-4 space-y-2 text-sm">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex justify-between"><span>{i.title}</span><span>{formatRupiah(i.price * i.quantity)}</span></div>
            ))}
            {order.discount > 0 && <div className="flex justify-between text-[#6B4BA3]"><span>Diskon</span><span>-{formatRupiah(order.discount)}</span></div>}
            <div className="flex justify-between font-semibold pt-2 border-t border-[#E2DFED]"><span>Total</span><span>{formatRupiah(order.total)}</span></div>
          </div>
        </div>
        <p className="text-sm text-[#5C5870] mb-6">Email konfirmasi akan dikirim ke <strong>{order.customer_email}</strong></p>
        <div className="flex gap-3 justify-center">
          <Link to="/profile" className="lumina-btn-outline">Lihat Pesanan Saya</Link>
          <Link to="/" className="lumina-btn-primary">Kembali ke Beranda</Link>
        </div>
      </div>
    </div>
  );
}
